import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../header/Header";
import Titulo from "../../atoms/titles/Titulo";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
const DescargarResolucionActos = () => {
  const navigate = useNavigate();
  const [solicitud, setSolicitud] = useState("");
  const location = useLocation();
  useEffect(() => {
    setSolicitud(location.state?.url && location.state.url);
  }, [location, location.state]);
  return (
    <>
      <Header></Header>
      <div className="container d-flex flex-column card mt-5" id="inicio">
        <div className="my-auto">
          <div className="container-login fondo">
            <div className="tituloSolicitud">
              <div className="d-flex align-items-center flex-column">
                <Titulo
                  titulo={"Acto S1 Variación de datos personales"}
                  tipo={"tituloPagina subTituloPagina"}
                />
                {/* <p className="text-third-1">{datos.estado}</p> */}
              </div>
              <div className="datosPersonalesCarrera d-flex flex-column m-2">
                <div>
                  <div className="d-flex justify-content-between">
                    <Titulo
                      clases={"subSubTituloSolicitud p-2 fw-bold"}
                      tipo={"tituloCard noBg"}
                      titulo={"Descargar Resolución"}
                    ></Titulo>
                  </div>
                  <div className="separador"></div>
                </div>

                <div className="formulario">
                  <>
                    <div className="m-2"></div>
                    <div className="m-3 card scroll-list container-list-border">
                      <div className="gridPresentar">
                        <div className="iframePresentar pt-3">
                          <object
                            data={solicitud}
                            type="application/pdf"
                            height="500"
                            width="100%"
                            aria-label="PDF del borrador"
                            className="rounded"
                            name="sol"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                  <div className="gridBotones mb-2">
                    <button
                      id="volver"
                      className="btnRed rounded btnCancelarDocumentacion"
                      type="button"
                      onClick={() => navigate("/variacionDatosPersonales")}
                    >
                      <i className="fa-solid fa-rotate-left"></i> Volver
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default DescargarResolucionActos;
